import Controller from "@ember/controller"
import { action, computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { tracked } from "@glimmer/tracking"
import belongsTo from "cc-frontend/helpers/belongs-to"
import classWebsiteViewAction from "cc-frontend/lib/actions/class-website/CLASS_WEBSITE_VIEW"
import moment from "cc-frontend/utils/extended-moment"
import _ from "lodash"

export default class ClassWebsiteController extends Controller {
  queryParams = ["date", "perspective", "selectedUnitId", "selectedCourseId"]

  @tracked date = null
  @tracked perspective = "week"
  @tracked selectedUnitId
  @tracked selectedCourseId

  date = moment().format("YYYY-MM-DD")

  @service dispatcher

  @service("ember-store") store

  @belongsTo("model", "classWebsite") classWebsite
  @belongsTo("classWebsite", "planbook") planbook
  @belongsTo("planbook", "rotationCalendar") rotationCalendar

  // FLAT OUT COPIED FROM PERSPECTIVE-WEEK. SUPER TACKY, SCOTT.
  @computed("date", "rotationCalendar.attributes.schoolDays")
  get dateStrings() {
    let validSchoolDays = get(this, "rotationCalendar.attributes.schoolDays")
    let date = get(this, "date")

    let startDate = moment(date).startOf("week")
    let endDate = moment(date).endOf("week")

    let range = moment.range(startDate, endDate)
    let acc = []
    Array.from(range.by("days")).map((moment) => {
      if (_.includes(validSchoolDays, moment.weekday())) acc.push(moment)
    })
    let newDates = _.uniq(_.map(acc, (m) => m.format("YYYY-MM-DD")))

    return newDates
  }

  @computed("dateStrings.[]")
  get dateRangeString() {
    var start = moment(get(this, "dateStrings.firstObject"))
    var end = moment(get(this, "dateStrings.lastObject"))
    var startMonth = start.format("MMMM")
    var endMonth = end.format("MMMM")
    if (startMonth === endMonth) {
      return start.format("MMMM D") + " - " + end.format("D, YYYY")
    } else {
      return start.format("MMM. D") + " - " + end.format("MMM. D, YYYY")
    }
  }

  @action
  setSelectedUnitId() {
    this.set("selectedUnitId")
  }

  @action
  previousDate() {
    var toSubtract = 1
    if (get(this, "perspective") === "week") {
      toSubtract = toSubtract + 6
    } else {
      if (moment(this.date).weekday() === 1) toSubtract = 3
    }
    var previousDate = moment(this.date).subtract(toSubtract, "days")
    this.set("date", previousDate.format("YYYY-MM-DD"))
  }

  @action
  nextDate() {
    var toAdd = 1
    if (get(this, "perspective") === "week") {
      toAdd = toAdd + 6
    } else {
      if (moment(this.date).weekday() === 5) toAdd = 3
    }
    var nextDate = moment(this.date).add(toAdd, "days")
    this.set("date", nextDate.format("YYYY-MM-DD"))
  }

  @action
  setNewDate(date) {
    this.set("date", moment(date).format("YYYY-MM-DD"))
  }

  @action
  goToPrevUnit(prevUnitId) {
    this.set("selectedUnitId", prevUnitId)
  }

  @action
  goToNextUnit(nextUnitId) {
    this.set("selectedUnitId", nextUnitId)
  }

  trackView = (perspective) => {
    this.classWebsite.promise.then((classWebsite) => {
      let planbookId = get(this, "classWebsite.relationships.planbook.data.id")
      let websiteId = get(this, "classWebsite.id")
      get(this, "dispatcher").dispatchPreparedAction(
        classWebsiteViewAction({
          perspective: perspective,
          planbookId: planbookId,
          websiteId: websiteId,
          classWebsite: classWebsite,
        })
      )
    })
  }
}
